if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.variantChangeUnsubscriber = null;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      connectedCallback() {
        super.connectedCallback?.();
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.variantChange) return;
        this.variantChangeUnsubscriber = subscribe(
          window.PUB_SUB_EVENTS.variantChange,
          this.syncQuickAddPrice.bind(this)
        );
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      syncQuickAddPrice(event) {
        if (event?.data?.sectionId) {
          const productInfo = this.modalContent?.querySelector('product-info');
          if (productInfo && productInfo.dataset.originalSection !== event.data.sectionId && productInfo.dataset.section !== event.data.sectionId) return;
        }
        setTimeout(() => this.syncQuickAddPriceInModal(), 50);
      }

      syncQuickAddPriceInModal() {
        if (!this.modalContent || !this.hasAttribute('open')) return;
        const productInfo = this.modalContent.querySelector('product-info');
        if (!productInfo) return;
        const sectionId = productInfo.dataset.section;
        if (!sectionId) return;
        const priceContainer = this.modalContent.querySelector(`#price-${sectionId}`);
        const cloneWrapper = this.modalContent.querySelector('.product-form__buttons .quick-add-price');
        if (!priceContainer || !cloneWrapper) return;
        cloneWrapper.innerHTML = priceContainer.innerHTML;
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        const content = this.querySelector('.quick-add-modal__content');
        const isMobileBottomSheet = window.matchMedia('(max-width: 749px)').matches &&
          content && !content.classList.contains('quick-add-modal__content--bulk');

        if (isMobileBottomSheet) {
          this.classList.add('is-closing');
          this.removeAttribute('open');
          let closed = false;
          const finishClose = () => {
            if (closed) return;
            closed = true;
            content.removeEventListener('transitionend', onTransitionEnd);
            clearTimeout(fallbackTimer);
            this.classList.remove('is-closing');
            this._priceSyncObserver?.disconnect();
            this._priceSyncObserver = null;
            if (this._priceChangeHandler) this.modalContent.removeEventListener('change', this._priceChangeHandler);
            this._priceChangeHandler = null;
            this.modalContent.innerHTML = '';
            if (preventFocus) this.openedBy = null;
            super.hide();
          };
          const onTransitionEnd = (e) => {
            if (e.target !== content || e.propertyName !== 'transform') return;
            finishClose();
          };
          const fallbackTimer = setTimeout(finishClose, 500);
          content.addEventListener('transitionend', onTransitionEnd);
          return;
        }

        this._priceSyncObserver?.disconnect();
        this._priceSyncObserver = null;
        if (this._priceChangeHandler) this.modalContent.removeEventListener('change', this._priceChangeHandler);
        this._priceChangeHandler = null;
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector('product-info');
          if (!productElement) return;

          // ❌ Remove custom-subscription element if present
          const customSub = productElement.querySelector("[id^='ordergroove_subscriptions_pdp_offer_block']");
          if (customSub) customSub.remove();
      
          this.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
      
          const insertedProduct = this.modalContent.querySelector('product-info');
          if (insertedProduct) this.repositionPrice(insertedProduct);
      
          const variantInput = this.modalContent.querySelector('input[name="id"]');
      
          /*if (variantInput) {
            // Define a function to update offer and trigger sub button
            const updateOfferAndTriggerSub = () => {
              const variantId = variantInput.value;
              const productUrl = opener?.getAttribute('data-product-url') || '';
              const productHandle = productUrl.split('/products/')[1]?.split('?')[0] || '';

              // console.log('CART PRODUCT TO HANDLE', productHandle);
      
              const offerMountPoint = this.modalContent.querySelector('.product__info-container');
              if (offerMountPoint) {
                let offer = offerMountPoint.querySelector('og-offer');
                let subbutton = offerMountPoint.querySelector('og-subscription-button');
                if (offer) {
                  offer.setAttribute('product', variantId);
                  offer.setAttribute('data-shopify-product-handle', productHandle);
                  offer.setAttribute('location', 'quick-add');
                  // offer.setAttribute('frequency', universalSelect.value);
                  // subbutton.setAttribute('frequency', universalSelect.value);
                }
              }
      
              requestAnimationFrame(() => {
                const subBtn = this.modalContent.querySelector('og-subscription-button');
                if (subBtn) subBtn.click();
              });
            };
      
            // Run once on initialization if there's a value
            if (variantInput.value) {
              updateOfferAndTriggerSub();
            }
      
            // Add event listener to update on variant changes
            variantInput.addEventListener('change', updateOfferAndTriggerSub);
          }*/
      
          // End custom universal frequency select code
      
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
      
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelectorAll('.breadcrumbs').forEach((el) => el.remove());

        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const pdpStickyAtc = productElement.querySelectorAll('.pdp-sticky-atc');
        if (pdpStickyAtc) pdpStickyAtc.forEach((bar) => bar.remove());

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // PDP markup nests <quick-add-modal> inside product-info; injecting it here would
        // upgrade a second modal outside .shopify-section and break ModalDialog.connectedCallback.
        productElement.querySelectorAll('quick-add-modal').forEach((el) => el.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));

        // Also adapt info layout for quick add
        this.repositionPrice(productElement);
      }

      /* Move price into the button row for quick add only (does not affect main product page) */
      repositionPrice(productElement) {
        const infoContainer = productElement.querySelector('.product__info-container');
        if (!infoContainer) return;

        const sectionId = productElement.dataset.section;
        if (!sectionId) return;

        const priceContainer = infoContainer.querySelector(`#price-${sectionId}`);
        const buttons = infoContainer.querySelector('.product-form__buttons');

        if (!priceContainer || !buttons) return;

        if (buttons.querySelector('.quick-add-price')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'quick-add-price';
        wrapper.innerHTML = priceContainer.innerHTML;
        buttons.insertBefore(wrapper, buttons.firstChild);

        priceContainer.style.display = 'none';

        const sync = () => this.syncQuickAddPriceInModal();

        if (typeof MutationObserver !== 'undefined') {
          this._priceSyncObserver?.disconnect();
          this._priceSyncObserver = new MutationObserver(sync);
          this._priceSyncObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        }

        this._priceChangeHandler = () => setTimeout(sync, 250);
        this.modalContent.addEventListener('change', this._priceChangeHandler);
      }
    }
  );
}
